import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//支付设置
export const paymethodindex= params=> {return addinstance().get(geturl(`/paymethod/index`),{params:params});}
export const paymethodcompany= params=> {return addinstance().get(geturl(`/paymethod/company`),{params:params});}
export const settingupdate= params => { return addinstance().post(geturl(`/setting/update`), params) };
export const settingindex= params=> {return addinstance().get(geturl(`/setting/index`),{params:params});}
export const paymethodupdate= params => { return addinstance().post(geturl(`/paymethod/update`), params) };
export const company_create= params => { return addinstance().post(geturl(`/paymethod/company_create`), params) };
export const company_update= params => { return addinstance().post(geturl(`/paymethod/company_update`), params) };
export const companydeletepay= params => { return addinstance().post(geturl(`/paymethod/company_delete`), params) };








// WEBPACK FOOTER //
// ./src/api/paymethodapi.js